import { StatusColors } from '@store/types'

import { slugify } from '@adUtilities/helper'
import { Unit } from '@adUtilities/types/apartment'

import { DEFAULT_STATUS_COLOUR } from './constants'

export const countUnitsByStatus = (units: Unit[], status: string) =>
  units.filter((unit) => unit.metas.status === status).length

export const getStatusColour = (statusColors: StatusColors, status = '') =>
  statusColors[slugify(status)] || DEFAULT_STATUS_COLOUR
